const getters = {
  getTalents: state => state.talents,
  getTotalTalent: state => state.totalTalent,
  getTalentsCategory: state => state.talentsCategory,
  getTalentListCity: state => state.listTalentCity,
  getTalentListNeighborhood: state => state.listTalentNeighborhood,
  getTalentProfileVideo: state => state.talentProfileVideo,
  getTalentsAlert: state => state.talentsAlert,
  getTotalAlertTalents: state => state.totalAlertTalents,
  getTalentAlertSettings: state => state.talentAlertSettings
}

export default getters
